// import Swiper JS
import Swiper from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';

document.addEventListener("DOMContentLoaded", () => {
    // init Swiper:
    const swiper = new Swiper('.article-swiper', {
        modules: [Navigation, A11y],
        loop: false,
        speed: 300,
        spaceBetween: 15,
        slidesPerView: 1.2,
        breakpoints: {
            992: {
                slidesPerView: 3,
                spaceBetween: 32,
            },
            768: {
                slidesPerView: 2.2,
                spaceBetween: 32,
            }
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });


    const swiper_filter = new Swiper('.swiper-filter', {
        modules: [Navigation, A11y],
        loop: false,
        freeMode: true,
        slidesPerView: 'auto',
        slidesPerGroupAuto: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    //related items slider on for example the theme detail page
    const swiper_related = new Swiper('.swiper-related-items', {
        modules: [Pagination, A11y],
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        loop: true,
        autoplay: false,
        speed: 1000,
        spaceBetween: 15,
        slidesPerView: 1.1,
        slidesPerGroup: 1,
        passiveListeners: true, //recommended for mobile performance
        centeredSlides: false,
        a11y: {
            paginationBulletMessage: 'Ga naar slide {{index}}',
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                slidesPerGroup: 1
            }
        },
    });

    // Swiper settings for tags on archive-advice page
    const swiper_editions = new Swiper ('.swiper-editions', {
        modules: [Navigation, A11y],
        loop: false,
        speed: 300,
        spaceBetween: 15,
        slidesPerView: 1.2,
        freeMode: true,
        freeModeMomentumRatio: 0.7,
        freeModeMomentumVelocityRatio: 0.7,
        breakpoints: {
            992: {
                slidesPerView: 2.4,
                spaceBetween: 30,
            },
            768: {
                slidesPerView: 1.4,
                spaceBetween: 30,
            }
        },

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
});
